<script>
  import { getContext } from "svelte";
  export let text = "";

  const { currentRace } = getContext("bga-race");

  $: label = `${text}${$currentRace === "black" ? "Black" : "white"}`;
</script>

<div class="race-toggle" aria-label={label}>
  <span class="race-toggle__label bga-race-ui-label">{text}</span>
  <button class:active={$currentRace === "black"} on:click>Black</button>
  <button class:active={$currentRace === "white"} on:click>white</button>
</div>

<style>
  .race-toggle {
    display: grid;
    grid-template: auto / repeat(2, minmax(1px, 1fr));
    gap: 0.25em;
    margin: 1em 0;
  }
  .race-toggle__label {
    margin-bottom: 0.75em;
    grid-column: 1 / -1;
  }

  button {
    font: bold 1em/1.3em var(--fonts-sans);
    display: block;
    border: none;
    background: #eee;
    height: var(--touch-target);
    color: var(--color-text-faded);

    transition: color 150ms ease-in-out, background 150ms ease-in-out;
  }

  button:hover {
    background: #ddd;
  }

  button:focus {
    outline: 1px solid var(--color-text);
  }

  button.active,
  button.active:hover {
    background: var(--color-accent);
    color: var(--color-accent-text);
    opacity: 1;
  }
</style>
